module.exports = __webpack_public_path__ + "static/img/bg-en.8f0a798d.webp";